// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"87b15a38","215":"ce8aa520","248":"1299ace7","257":"d244ec59","364":"caa79422","545":"4be387d1","754":"47bfcaea","945":"7ebebe9f","991":"3fa43909"}[chunkId] + ".chunk.js";
};